import UserActions from 'app/shared/flux/actions/UserActions';

// @ts-ignore
const serverRouteWillMount = ({ store }) => {
  const { dispatch } = store;

  return dispatch(UserActions.getUser());
};

export default serverRouteWillMount;
